import './App.css';
import {Component} from "react";
import {init, searchTable} from "../helpers/MapHelper";
import logo_cena_en_rojo from "../images/cena en rojo_cuadrado.svg"
import {backToMap, enviarFactura, handleBlur, handleFocus, handleKeyUp, validatePass} from "../helpers/Actions";

import {
    continueToContactDatas,
    decrementarAsientos,
    incrementarAsientos,
    makeContact, makePayment,
    showMap,
    start
} from "../helpers/Actions";
import Dialogs from "./Dialogs/Dialogs";


export default class App extends Component {
    componentDidMount() {
        setTimeout(init, 1000)
    }

    render() {
        return (
            <div className="App">
                <div className="image-container ">
                    <img src={logo_cena_en_rojo} alt="" className="logo_cena"/>
                    <button onClick={start}>Entrar</button>

                    <small>Al participar en el evento, autorizas a Save the Children México a usar tu imagen (fotos y videos) para difusión interna y externa sin compensación. Tu consentimiento es voluntario, puedes revocarlo por escrito y ejercer tus derechos ARCO mediante el correo datos.personales@savethechildren.org</small>
                    <small>* Para asegurar el mejor desarrollo del evento, la distribución de las mesas podría sufrir ajustes de último momento. <br/> Gracias por su comprensión.</small>

                </div>
                <div className="step step-1 hide">
                    <h1 className="d-none">Paso 1</h1>


                    <button className='ajustar d-none' onClick={showMap}>
                        Selecciona la mesa de tu preferencia
                    </button>

                    <div className="separador d-none">
                        <div className="line"></div>
                        <b>O</b>
                        <div className="line"></div>
                    </div>

                    <b className="text-center">
                        Ingresa la contraseña proporcionada
                    </b>
                    <input type="text" id="contraseña" onKeyUp={validatePass}/>
                    <button className="search" onClick={searchTable}>Buscar mesa</button>

                </div>
                <div className="step step-2 hide">
                    <div className="info">
                        <h2>Datos Seleccionados</h2>
                        <br/>
                        <input type="hidden" id="status" value={0}/>
                        <div className="data-group mesa-group">
                            <label htmlFor="">Mesa: </label>
                            <div className="data">
                                <div className="text">
                                </div>
                                <input type="hidden" id="mesa"/>
                            </div>
                        </div>
                        <div className="data-group precio-group">
                            <label htmlFor="">Precio por asiento: </label>
                            <div className="data">
                                <div className="text precio"></div>
                                <input type="hidden" id="precio"/>
                            </div>
                        </div>
                        <div className="data-group asientos-group">
                            <label htmlFor="">Número de asientos: </label>
                            <div className="data">
                                <div className="text">
                                    <button className="minus" onClick={decrementarAsientos}>-</button>
                                    <div className="cantidad">1</div>
                                    <button className="plus" onClick={incrementarAsientos}>+</button>
                                </div>
                                <input type="hidden" id="asientos" value={1}/>
                            </div>
                        </div>
                        <div className="data-group">
                            <label htmlFor="">Total a pagar: </label>
                            <div className="data">
                                <div className="text total">
                                </div>
                                <input type="hidden" id="total"/>
                            </div>
                        </div>
                        <button className="datas-1 continue" onClick={continueToContactDatas}>
                            Continuar
                        </button>
                        <button className="back-to-map" onClick={backToMap}>
                            Regresar
                        </button>
                    </div>
                    <div className="map-container ">
                        <div className="escenario">
                            Escenario
                        </div>
                        <div className="rule">
                            SELECCIONA TUS LUGARES.
                            <br/>
                            <div className="nomenglatura">
                                <div className="nomenglatura-container">
                                    <div className="asiento asiento-0"></div>
                                    Asiento disponible
                                </div>
                                <div className="nomenglatura-container">
                                    <div className="asiento"></div>
                                    Asiento ocupado
                                </div><br/>
                            </div>
                        </div>
                        <div className="work-station">
                            <div className="map">
                            </div>
                        </div>
                    </div>
                </div>
                <div className="step step-3 hide">
                    <h2>Datos de contacto</h2>
                    <div className="form-group">
                        <label htmlFor="">Nombre(s):</label>
                        <input type="text" className="firstName" id="firstName" onFocus={handleFocus}
                               onBlur={handleBlur} onKeyUp={handleKeyUp}/>
                    </div>
                    <div className="form-group ">
                        <label htmlFor="">Apellidos</label>
                        <input type="text" className="lastName" id="lastName" onFocus={handleFocus} onBlur={handleBlur}
                               onKeyUp={handleKeyUp}/>
                    </div>
                    <div className="form-group">
                        <label htmlFor="">Correo electrónico</label>
                        <input type="email" className="email" id="email" onFocus={handleFocus} onBlur={handleBlur}
                               onKeyUp={handleKeyUp}/>
                    </div>
                    <div className="form-group">
                        <label htmlFor="">Teléfono celular</label>
                        <input type="text" className="phone" id="phone" onFocus={handleFocus} onBlur={handleBlur}
                               onKeyUp={handleKeyUp}/>
                    </div>
                    <input type="hidden" name="utm_source" id="utm_source" placeholder="UTM Source"/>
                    <input type="hidden" name="utm_medium" id="utm_medium" placeholder="UTM Medium"/>
                    <input type="hidden" name="utm_campaign" id="utm_campaign" placeholder="UTM Campaign"/>
                    <input type="hidden" name="utm_term" id="utm_term" placeholder="UTM Term"/>
                    <input type="hidden" name="utm_content" id="utm_content" placeholder="UTM Content"/>
                    <input type="hidden" name={"currency"} id={"currency"} value={"mxn"}/>
                    <input type="hidden" id={"asientos_apartados"}/>
                    <button onClick={makeContact} className="continue">Continuar al pago</button>
                </div>
                <div className="step step-4 hide">
                    <h2>Datos Bancarios</h2>
                    <div className="form-group normal">
                        <label htmlFor="">Titular</label>
                        <input type="text" id="titular" onFocus={handleFocus} onBlur={handleBlur}
                               onKeyUp={handleKeyUp}/>
                    </div>
                    <div className="form-group normal">
                        <label htmlFor="">Número de tarjeta</label>
                        <input type="text" id="tarjeta" onFocus={handleFocus} onBlur={handleBlur}
                               onKeyUp={handleKeyUp}/>
                    </div>
                    <div className="form-group normal">
                        <label htmlFor="">Mes de vencimiento (MM)</label>
                        <input type="text" id="mes" onFocus={handleFocus} onBlur={handleBlur} onKeyUp={handleKeyUp}/>
                    </div>
                    <div className="form-group normal">
                        <label htmlFor="">Año de vencimiento (AA)</label>
                        <input type="text" id="year" onFocus={handleFocus} onBlur={handleBlur} onKeyUp={handleKeyUp}/>
                    </div>
                    <div className="form-group normal">
                        <label htmlFor="">CVV</label>
                        <input type="text" id="cvv" onFocus={handleFocus} onBlur={handleBlur} onKeyUp={handleKeyUp}/>
                    </div>
                    <input type="hidden" id={"contact"}/>
                    <input type="hidden" id={"deal"}/>
                    <input type="hidden" id={"new"}/>
                    <input type="hidden" id={"payment_intent"}/>
                    <button onClick={makePayment} className="continue">Pagar</button>
                </div>
                <div className="step step-5 hide">
                    <h2>Compra exitosa</h2>
                    <div className="calendars">
                        <a href="" className="google-calendar d-none" target="_blank">
                            <button>
                                Agregar a Google Calendar
                            </button>
                        </a>
                        <a href="" className="i-calendar d-none">
                            <button>
                                Agregar a iCalendar
                            </button>
                        </a>
                    </div>
                    <br/>
                    <p> Por favor proporciona tus datos fiscales.</p>
                    <div className="form-group">
                        <label htmlFor="">Email de facturación</label>
                        <input type="text" id="email-facturacion" onFocus={handleFocus} onBlur={handleBlur}
                               onKeyUp={handleKeyUp}/>
                    </div>
                    <div className="form-group">
                        <label htmlFor="">RFC:</label>
                        <input type="text" id="rfc" onFocus={handleFocus} onBlur={handleBlur} onKeyUp={handleKeyUp}/>
                    </div>
                    <div className="form-group">
                        <label htmlFor="">Razón social:</label>
                        <input type="text" id="razon_social" onFocus={handleFocus} onBlur={handleBlur} onKeyUp={handleKeyUp}/>
                    </div>
                    <div className="form-group focus is-valid d-none">
                        <label htmlFor="">Tipo de documento</label>
                        <input type="text" id="tipo_documento" value="DI"/>
                    </div>
                    <div className="form-group">
                        <label htmlFor="">Código postal: </label>
                        <input type="text" id="cp_fiscal" onFocus={handleFocus} onBlur={handleBlur} onKeyUp={handleKeyUp}/>
                    </div>
                    <div className="form-group focus is-valid">
                        <label htmlFor="">Régimen fiscal</label>
                        <select id="regimen_fiscal">
                            <option value="622 - Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras">622 - Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras</option>
                            <option value="606 - Arrendamiento">606 - Arrendamiento</option>
                            <option value="609 - Consolidación">609 - Consolidación</option>
                            <option value="624 - Coordinados">624 - Coordinados</option>
                            <option value="629 - De los Regímenes Fiscales Preferentes y de las Empresas Multinacionales">629 - De los Regímenes Fiscales Preferentes y de las Empresas Multinacionales</option>
                            <option value="608 - Demás ingresos">608 - Demás ingresos</option>
                            <option value="630 - Enajenación de acciones en bolsa de valores">630 - Enajenación de acciones en bolsa de valores</option>
                            <option value="601 - General de Ley Personas Morales">601 - General de Ley Personas Morales</option>
                            <option value="628 - Hidrocarburos">628 - Hidrocarburos</option>
                            <option value="621 - Incorporación Fiscal">621 - Incorporación Fiscal</option>
                            <option value="611 - Ingresos por Dividendos (socios y accionistas)">611 - Ingresos por Dividendos (socios y accionistas)</option>
                            <option value="614 - Ingresos por intereses">614 - Ingresos por intereses</option>
                            <option value="623 - Opcional para Grupos de Sociedades">623 - Opcional para Grupos de Sociedades</option>
                            <option value="612 - Personas Físicas con Actividades Empresariales y Profesionales">612 - Personas Físicas con Actividades Empresariales y Profesionales</option>
                            <option value="603 - Personas Morales con Fines no Lucrativos">603 - Personas Morales con Fines no Lucrativos</option>
                            <option value="607 - Régimen de Enajenación o Adquisición de Bienes">607 - Régimen de Enajenación o Adquisición de Bienes</option>
                            <option value="625 - Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas">625 - Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas</option>
                            <option value="615 - Régimen de los ingresos por obtención de premios">615 - Régimen de los ingresos por obtención de premios</option>
                            <option value="626 - Régimen Simplificado de Confianza">626 - Régimen Simplificado de Confianza</option>
                            <option value="610 - Residentes en el Extranjero sin Establecimiento Permanente en México">610 - Residentes en el Extranjero sin Establecimiento Permanente en México</option>
                            <option value="616 - Sin obligaciones fiscales">616 - Sin obligaciones fiscales</option>
                            <option value="620 - Sociedades Cooperativas de Producción que optan por diferir sus ingresos">620 - Sociedades Cooperativas de Producción que optan por diferir sus ingresos</option>
                            <option value="605 - Sueldos y Salarios e Ingresos Asimilados a Salarios">605 - Sueldos y Salarios e Ingresos Asimilados a Salarios</option>
                        </select>
                    </div>
                    <button onClick={enviarFactura} className="continue">Enviar</button>
                </div>
                <Dialogs/>
            </div>
        );
    }
}

